<template>
    <v-container fill-height fluid pa-0>
        <animated-background></animated-background>
        <v-row align="center" justify="center">
            <div style="position: absolute; top: 180px;">
                <v-item-group :value="currentPhase" mandatory>
                    <v-row align="center" justify="center">
                        <div style="background-color: rgba(255,255,255,0.2); height: 25px; width: 100%; border-radius: 5px; position: absolute; left: 0;"></div>
                        <v-col :key="phase.journeyphaseid"
                               v-for="(phase, index) in $store.state.journey.journey.journeyphases"
                        >
                            <v-item v-slot:default="{ active, toggle }">
                                <v-card :color="active ? 'primary' : 'transparent'"
                                        @click="setPhaseSelection(index)"
                                        class="text-center px-3 py-1"
                                        style="z-index: 1; user-select: none;"
                                        :flat="!active"
                                        :style="{ 'box-shadow': active ? '0 0 0 1px white' : '' }"
                                >
                                    {{ $ta(phase.title_textassetid) }}
                                </v-card>
                            </v-item>
                        </v-col>
                    </v-row>
                </v-item-group>
            </div>
            <v-col cols="12">
                <v-window v-model="currentPhase">
                    <v-window-item :key="phase.journeyphaseid"
                                   v-for="(phase, index) in phases"
                    >
                        <div style="height: 200px;">
                            <journey-progress-bar
                                :current-phase="$store.state.journey.journey.journeyphases[currentPhase]"
                                v-if="currentPhase === index"
                                :delay="500"
                                :completed="phaseCompleted"
                                :active="phaseActive"
                            ></journey-progress-bar>
                        </div>
                    </v-window-item>
                </v-window>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import JourneyProgressBar from "../../components/journey/JourneyProgressBar";
    import AnimatedBackground from "../../components/display/AnimatedBackground";

    export default {
        components: {
            JourneyProgressBar,
            AnimatedBackground
        },
        name: "JourneyProgressPlan",
        computed: {
            getActivePhase() {
                return this.$store.state.assessment.journeyplan.journeyphase;
            },
            phases() {
                return this.$store.state.journey.journey.journeyphases;
            },
            phaseCompleted() {
                let activeOrder = this.getActivePhase.phaseorder;
                return this.currentPhase < activeOrder;
            },
            phaseActive() {
                let activeOrder = this.getActivePhase.phaseorder;
                return activeOrder === this.currentPhase;
            }
        },
        data: () => ({
            currentPhase: null,
        }),
        methods: {
            setPhaseSelection(event) {
                this.currentPhase = event;
            }
        },
        mounted() {
            this.currentPhase = (this.getActivePhase.phaseorder);
        }
    }
</script>

<style scoped>

</style>